import styled from 'styled-components';
import { setIconColor } from 'modules/utils/cssUtils';
import { Flex } from '../flex';
import { theme } from '../theme';
import { NavigationAndActionAdd } from '../icons';

export const AccordionDiv = styled(Flex)<{
  active: boolean;
}>`
  width: 100%;

  padding-top: 1rem;
  padding-bottom: 0.5rem;
  border-width: 1px;
  border-color: ${theme.colors.primaryK3};
  border-style: solid none solid none;
  margin: 0.8rem 0;

  ${(props) =>
    props.active
      ? `
    border-bottom: 1px solid ${theme.colors.primaryK4};
  `
      : ''}
`;

export const AccordionTitle = styled(Flex)<{
  active: boolean;
}>`
  flex-direction: row;
  h4 {
    margin-left: 0.8rem;
  }

  svg {
    width: 1.266rem;
    height: 1.266rem;
    margin: 0.18rem 0 0 0.8rem;
  }

  ${(props) =>
    props.active
      ? `
        h4 { 
          color: ${theme.colors.primaryT2};
        }
        `
      : ''}

  :hover {
    cursor: pointer;
    svg {
      ${setIconColor(theme.colors.primaryK7)};
    }
    h4 {
      color: ${theme.colors.primaryK7};
    }
  }
`;

export const AccordionContent = styled.div<{
  isOpen: boolean;
}>`
  margin: 1rem;
  overflow: hidden;
  transition: max-height 0.4s, margin-top 0.4s, margin-bottom 0.4s ease-in-out;

  ${(props) =>
    props.isOpen
      ? `
        max-height: 20rem;
      `
      : `
        max-height: 0;
        margin-bottom: 0;
        margin-top: 0;
      `}
`;

export const Arrow = styled(Flex)<{
  active?: boolean;
}>`
  width: 1rem;
  height: 0.625rem;
  position: relative;
  user-select: none;
  cursor: pointer;
  margin: 0.4rem 1rem 0 0;
  :hover {
    cursor: pointer;
  }

  svg {
    width: 1rem;
    height: 0.625rem;
  }

  ${(props) =>
    props.active
      ? `
    ${setIconColor(theme.colors.primaryT2)};
    `
      : ''};
`;

export const IconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.1rem;
`;

export const AddButton = styled(NavigationAndActionAdd)`
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 0.5rem;
  path {
    fill: ${theme.colors.primaryT2};
  }
  :hover {
    cursor: pointer;
    path {
      fill: ${theme.colors.primaryT1};
    }
  }
`;
